import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ERPConnectionCustomer } from '../models/erpconnectioncustomer.model';
import { ERPConnectionContact } from '../models/erpconnectioncontact.model';
import { ERPConnectionCustomerAddressBookRecord } from '../models/erpconnectioncustomeraddressbookrecord.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ErpconnectioncustomerService {

	private svcUrl = '/ERPConnectionCustomers';

	constructor(private http: HttpClient, private url: UrlService) { }

	getERPConnectionCustomer(id: number): Observable<ERPConnectionCustomer> {
		return this.http.get<ERPConnectionCustomer>(this.url.getBaseURL() + this.svcUrl + '/' + id);
	}

	getERPConnectionCustomersByERPId(id: string): Observable<ERPConnectionCustomer> {
		return this.http.get<ERPConnectionCustomer>(this.url.getBaseURL() + this.svcUrl + '/ERPId/' + id);
	}

	getERPConnectionCustomersByERPConnectionId(id: number): Observable<ERPConnectionCustomer[]> {
		return this.http.get<ERPConnectionCustomer[]>(this.url.getBaseURL() + this.svcUrl + '/CustomersByERPConnectionId/' + id);
	}

	getERPConnectionContactsByERPConnectionCustomerId(id: number): Observable<ERPConnectionContact[]> {
		return this.http.get<ERPConnectionContact[]>(this.url.getBaseURL() + this.svcUrl + '/ContactsByERPConnectionCustomerId/' + id);
	}

	getAddressBookByERPConnectionCustomerId(id: number): Observable<ERPConnectionCustomerAddressBookRecord[]> {
		return this.http.get<ERPConnectionCustomerAddressBookRecord[]>(this.url.getBaseURL() + this.svcUrl + '/AddressBookByERPConnectionCustomerId/' + id);
	}

	getERPConnectionCustomersByBrokerId(id: number): Observable<ERPConnectionCustomer[]> {
		return this.http.get<ERPConnectionCustomer[]>(this.url.getBaseURL() + this.svcUrl + '/Broker/' + id);
	}

	updateEmailDomain(item: ERPConnectionCustomer): Observable<ERPConnectionCustomer> {
		return this.http.post<ERPConnectionCustomer>(this.url.getBaseURL() + this.svcUrl + '/UpdateEmailDomain', item);
	}

	refreshCustomers(id: number): Observable<ERPConnectionCustomer[]> {
		return this.http.post<ERPConnectionCustomer[]>(this.url.getBaseURL() + this.svcUrl + '/RefreshCustomers/' + id, {});
	}

	refreshContacts(id: number): Observable<ERPConnectionContact[]> {
		return this.http.post<ERPConnectionContact[]>(this.url.getBaseURL() + this.svcUrl + '/RefreshContacts/' + id, {});
	}

	refreshAddressBook(id: number): Observable<ERPConnectionCustomerAddressBookRecord[]> {
		return this.http.post<ERPConnectionCustomerAddressBookRecord[]>(this.url.getBaseURL() + this.svcUrl + '/RefreshAddressBook/' + id, {});
	}

}
